import React from 'react';
//@ts-ignore
import * as styles from './blog-detail-masthead.module.css';
import { BlogDetailMastheadProps } from './index';
import RichText from '../Global/RichText';
import { getColor, getMediaData } from '../Global/DataUtils';
import { Taxonomy } from '../../templates/TaxonomyContext';

interface Props extends BlogDetailMastheadProps {
    blogTopics?: Taxonomy[];
    pageMetadata: {
        blogTitle?: string;
        blogShortDescription?: string;
    };
}

const BlogDetailMasthead: React.FC<Props> = ({
    display_publish_date,
    top_summary,
    blogTopics,
    text_background_color,
    text_background_opacity,
    pageMetadata,
    ...props
}) => {
    const largeMastheadImage = getMediaData(
        props.general_large___small_image_selection__large
    );
    const smallMastheadImage = getMediaData(
        props.general_large___small_image_selection__small
    );
    const backgroundOpacity = text_background_opacity.value / 100 || 1;
    const backgroundColor = getColor(text_background_color) || '#4b5f5e';
    const authorStyles = {
        backgroundColor:
            backgroundColor + backgroundOpacity.toString(16).slice(2, 4),
    };

    return (
        <section className={styles.wrapper}>
            <div className={styles.mastheadImage}>
                {largeMastheadImage && (
                    <picture>
                        {smallMastheadImage && (
                            <source
                                media="(max-width: 576px)"
                                srcSet={smallMastheadImage.url}
                            />
                        )}

                        <img
                            src={largeMastheadImage.url}
                            alt={
                                largeMastheadImage.description ||
                                largeMastheadImage.name
                            }
                        />
                    </picture>
                )}
            </div>
            <div className={styles.headlinePanel} style={authorStyles}>
                <div className={styles.subheading}>
                    {display_publish_date.value}
                </div>
                <h1>{pageMetadata.blogTitle}</h1>
                {blogTopics?.length &&
                    blogTopics?.map((topic, idx) => {
                        return (
                            <React.Fragment key={idx}>
                                <span className={styles.topicLink}>
                                    {topic.name}
                                </span>
                                {idx != blogTopics.length - 1 && `, `}
                            </React.Fragment>
                        );
                    })}
            </div>
            <div className={styles.summary}>{RichText(top_summary)}</div>
        </section>
    );
};

function setAuthorStyles(brandColor: string, opacity: number) {
    return {
        backgroundColor: brandColor,
        opacity: opacity,
    };
}

export default BlogDetailMasthead;
